module.exports = __webpack_public_path__ + "02_mole.6c042b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/02_mole.png
// module id = rZf0
// module chunks = 0